/* eslint-disable max-lines */
import { startCase } from 'lodash';
import React, { useState } from 'react';
import { getAllowUserProfile } from 'selectors/auth';
import { useSelector } from 'store';
import UserProfile from './UserProfile';

type ComponentProps = {
  userId: string;
  userName: string;
  userEmail: string;
  isTeamsComm?: boolean;
  highlight?: boolean;
};

const UserEmail: React.FC<ComponentProps> = ({
  userId,
  userName,
  userEmail,
  isTeamsComm = false,
  highlight = false,
}) => {
  const allowUserProfile = useSelector(getAllowUserProfile);

  const [profileOpen, setProfileOpen] = useState(false);

  const handleClick = (): void => {
    setProfileOpen(true);
  };

  return (
    <div className="flex flex-col">
      <button
        type="button"
        className={`px-2 pt-1 flex text-body border rounded-full focus:outline-none ${
          userId && allowUserProfile ? 'hover:bg-litlingo-gray-1' : 'cursor-default'
        }
        ${highlight ? 'border-litlingo-success' : 'border-litlingo-gray-1'}  
        `}
        onClick={handleClick}
      >
        <div className="flex flex-row gap-1 whitespace-no-wrap">
          <span>{startCase(userName)}</span>
          {!isTeamsComm && <span className="text-litlingo-info">{userEmail}</span>}
        </div>
      </button>
      {userId && allowUserProfile && profileOpen && (
        <UserProfile userId={userId} setProfileOpen={setProfileOpen} />
      )}
    </div>
  );
};

export default UserEmail;
